import { ISelectedNode } from "../models/node";
import { generateChartColor, getRgbaFromRgb, IRgb } from "./Color";
export function getDataIndexes(data, headers) {
    if (!data || data.length === 0 || !headers || headers.length === 0) {
        return null;
    }
    var indexes = [];
    for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
        var item = data_1[_i];
        var index = headers.map(function (header) { return header && header.name; }).indexOf(item && item.value);
        if (index !== -1) {
            indexes.push(index);
        }
    }
    return indexes;
}
export function getDataSets(rows, headers, indexes) {
    if (!rows || rows.length === 0 || !headers || headers.length === 0 || !indexes || indexes.length === 0) {
        return null;
    }
    var datasets = [];
    for (var _i = 0, indexes_1 = indexes; _i < indexes_1.length; _i++) {
        var index = indexes_1[_i];
        var dataset = [];
        for (var _a = 0, rows_1 = rows; _a < rows_1.length; _a++) {
            var row = rows_1[_a];
            dataset.push(row[index]);
        }
        datasets.push({
            label: headers[index] && headers[index].title,
            data: dataset,
            borderWidth: 2,
        });
    }
    return datasets;
}
export function getChartLabels(rows, indexes) {
    if (!rows || rows.length === 0 || !indexes || indexes.length === 0) {
        return null;
    }
    var labels = [];
    for (var _i = 0, rows_2 = rows; _i < rows_2.length; _i++) {
        var row = rows_2[_i];
        var rowLabels = [];
        for (var _a = 0, indexes_2 = indexes; _a < indexes_2.length; _a++) {
            var index = indexes_2[_a];
            rowLabels.push(row[index]);
        }
        labels.push(rowLabels.join(', '));
    }
    return labels;
}
export function customizeOvalChartLabel(item, data) {
    return data.labels[item.index] + ". " + data.datasets[item.datasetIndex].label + ": " + data.datasets[item.datasetIndex].data[item.index];
}
export function customizeRadarChartLabel(item, data) {
    return data.datasets[item.datasetIndex].label + ": " + data.datasets[item.datasetIndex].data[item.index];
}
export function generateChartColors(labels, datasets, baseChartColors) {
    if ((!labels || labels.length === 0) && (!datasets || datasets.length === 0)) {
        return null;
    }
    var generator = [];
    if (!labels) {
        generator = datasets;
    }
    else if (!datasets) {
        generator = labels;
    }
    else if (labels.length >= datasets.length) {
        generator = labels;
    }
    else {
        generator = datasets;
    }
    var backgroundColor = [];
    var borderColor = [];
    generator.forEach(function (item, index) {
        var rgb = generateChartColor(baseChartColors, index);
        backgroundColor.push(getRgbaFromRgb(rgb, 0.4));
        borderColor.push(getRgbaFromRgb(rgb, 1));
    });
    return {
        backgroundColor: backgroundColor,
        borderColor: borderColor,
    };
}
export function colorizeChart(datasets, backgroundColor, borderColor) {
    if (!datasets || datasets.length === 0 || !backgroundColor || !borderColor) {
        return;
    }
    datasets.forEach(function (dataset, index) {
        dataset.backgroundColor = backgroundColor[index];
        dataset.borderColor = borderColor[index];
    });
}
export function colorizeOvalChart(datasets, backgroundColor, borderColor) {
    if (borderColor === void 0) { borderColor = '#fff'; }
    if (!datasets || datasets.length === 0 || !backgroundColor) {
        return;
    }
    datasets.forEach(function (dataset) {
        dataset.backgroundColor = backgroundColor;
        dataset.borderColor = borderColor;
    });
}
